<template>
  <div class="credit-table">
    <v-data-table
      :footer-props="{
        'items-per-page-text': 'Số dữ liệu mỗi trang',
        'items-per-page-options': [10, 20, 50]
      }"
      disable-sort
      :headers="headers"
      :items="studentCredits"
      :loading="loading"
      :items-per-page="itemsPerPage"
      :server-items-length="count"
      no-data-text="Không có dữ liệu"
      @update:page="val => updatePagination('page', val)"
      @update:items-per-page="val => updatePagination('itemsPerPage', val)"
    >
      <template v-slot:[`item.student`]="{ item }">
        <card-student-name :student="item.student || {}" link />
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex">
          <div v-if="$auth.policies['view-detail-student-credit']" class="mx-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs" class="d-inline-flex cursor-pointer">
                  <v-icon
                    @click="() => $router.push(`/student-credit/${item.id}`)"
                    size="20"
                    class="ml-2"
                    color="primary"
                    >mdi-eye</v-icon
                  >
                </div>
              </template>
              <span class="white--text text-justify">
                {{ 'Xem hoạt động gần đây' }}
              </span>
            </v-tooltip>
          </div>
          <div v-if="$auth.policies['charge-student-credit']" class="mx-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs" class="d-inline-flex cursor-pointer">
                  <v-icon @click="() => onRecharge(item || {})" size="20" class="ml-2" color="primary"
                    >mdi-transfer-up</v-icon
                  >
                </div>
              </template>
              <span class="white--text text-justify">
                {{ 'Nạp thêm trực tiếp' }}
              </span>
            </v-tooltip>
          </div>
        </div>
      </template>
    </v-data-table>
    <DialogConfirmRecharge ref="confirm-recharge" />
  </div>
</template>

<script>
import { get } from 'lodash'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import DialogConfirmRecharge from './components/DialogConfirmRecharge.vue'
import { mapActions, mapState } from 'vuex'
export default {
  components: { CardStudentName, DialogConfirmRecharge },
  computed: {
    ...mapState({
      studentCredits(state) {
        return state['studentCredit'].studentCredits.map((v, i) => ({
          ...v,
          index: this.itemsPerPage * (this.page - 1) + i + 1,
          value: Number(v.value).toLocaleString('en-US')
        }))
      },
      count(state) {
        return state['studentCredit'].count
      },
      filter(state) {
        return state['studentCredit'].filter
      },
      itemsPerPageState(state) {
        return state['studentCredit'].itemsPerPage
      },
      loading(state) {
        return state['studentCredit'].loading
      }
    })
  },
  created() {
    if (!this.$auth.policies['view-detail-student-credit'] && !this.$auth.policies['charge-student-credit']) {
      this.headers = this.headers.filter(v => v.value !== 'actions')
    }
  },
  data() {
    return {
      headers: [
        { text: 'STT', value: 'index', align: 'center', width: '40px' },
        { text: 'Học sinh', value: 'student' },
        { text: 'Credit hiện tại', value: 'value', width: '200px', align: 'end' },
        { text: 'Thao tác', value: 'actions', align: 'center', width: '100px' }
      ],
      itemsPerPage: 10,
      page: 1,
      totalCount: 11,
      get
    }
  },
  methods: {
    ...mapActions({
      find: 'studentCredit/fetch',
      setItemsPerPage: 'studentCredit/setItemsPerPage',
      setLoading: 'studentCredit/setLoading'
    }),
    async updatePagination(type, val) {
      this.setLoading(true)
      try {
        const page = type === 'page' ? val : 1
        const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPageState
        await this.find({
          _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          ...this.filter
        })
        this.setItemsPerPage(itemsPerPage)
        this.itemsPerPage = itemsPerPage
        this.page = page
      } finally {
        this.setLoading(false)
      }
    },
    onRecharge(data) {
      if (data && data.id) {
        this.$refs['confirm-recharge'].openDialog(data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.credit-table {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
